module.exports = __webpack_public_path__ + "static/media/icon_love_on.05a5fd90.svg";